<template src="./search-template.vue" />
<script>
import indexMixin from './index-mixin';

export default {
  name: 'SearchComponent',

  mixins: [indexMixin],

  data() {
    return {
      config: {
        type: 'reviews',
        sortFields: [
          {
            title: 'Most Relevant',
            value: 'most_relevant',
          },
          {
            title: 'Newest Reviews',
            value: 'date-desc',
          },
          {
            title: 'Oldest Reviews',
            value: 'date-asc',
          },
          {
            title: 'Highest Rated',
            value: 'rating-desc',
          },
          {
            title: 'Lowest Rated',
            value: 'rating-asc',
          },
        ],
        availableFilters: {
          jobType: true,
          jobRole: true,
          location: true,
          ted: true,
          companyIndustry: false,
        },
      },
    };
  },
};
</script>

